<div class="card">
  <h5 class="card-header">
    <div class="flex-between">
      <div>
        <button class="btn btn-light m-0" (click)="onBack()">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          Workloads
        </button>
        <span class="selected-workload-name">{{ selectedWorkload?.workload_name }}</span>
      </div>
      <div class="flex-start">
        <button class="btn btn-light m-0" (click)="onRefresh()">
          <i class="fa fa-refresh"></i>
          Refresh
        </button>
      </div>
    </div>
  </h5>

  <div class="card-body">
    <div class="alert alert-danger" *ngIf="workloadSummaryError">
      {{ workloadSummaryError }}
    </div>

    <div class="text-center py-3" *ngIf="workloadSummaryLoading">
      <img src="assets/img/loading_2.svg" alt="loading summary" class="loader-icon" />
    </div>

    <div *ngIf="!workloadSummaryLoading && workloadSummary">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Lenses</h5>
        </div>
        <div class="card-body">
          <app-azure-wafr-lenses
            [lenses]="workloadSummary?.lenses || []"
            (openLens)="onOpenLens($event)"
          ></app-azure-wafr-lenses>
        </div>
      </div>
    </div>
  </div>
</div>
